// The Entry Groups list row for an entry group the popup just reloaded. The popup reloads it with
// get_entry_group (cards, no counts), which replaces the row admin_home_2 built; without this the
// row's entry count went blank and its species and pre-entry counts were lost until a page reload.
// Counts come from the cards: entry_count is the live rows (one per show), as admin_home_2 counts
// them; pre_entry_count is the pre-entry cards (one per future animal), in total and per exhibitor.
// What only admin_home_2 knows (species counts, date of birth) is kept from the old row.
export function entryGroupListRow (reloaded, previous) {
  const cards = reloaded.entries || []
  const oldExhibitors = {}
  ;((previous && previous.exhibitors) || []).forEach(ex => { oldExhibitors[ex.exhibitor_id] = ex })
  const preEntries = {}
  cards.forEach(c => {
    if (!c.pre_entry_key) return
    preEntries[c.exhibitor_id] = (preEntries[c.exhibitor_id] || 0) + 1
  })
  return {
    ...(previous || {}),
    ...reloaded,
    exhibitors: (reloaded.exhibitors || []).map(ex => ({
      ...(oldExhibitors[ex.exhibitor_id] || {}),
      ...ex,
      pre_entry_count: preEntries[ex.exhibitor_id] || 0
    })),
    entry_count: cards.reduce((n, c) => n + ((c.entry_ids && c.entry_ids.length) || 0), 0),
    pre_entry_count: Object.values(preEntries).reduce((n, c) => n + c, 0)
  }
}
